"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const adminClient_1 = require("src/client/adminClient");
const Dropdown_1 = __importDefault(require("src/components/design-system/dropdown/Dropdown"));
const Trigger_1 = __importDefault(require("src/components/design-system/dropdown/Trigger"));
const LoadingComponent_1 = __importDefault(require("src/components/shared/LoadingComponent"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs_1.default.extend(localizedFormat);
const dateFormatter = (start, end) => {
    return `${(0, dayjs_1.default)(start).format('HH.mm, D MMM YYYY')} - ${(0, dayjs_1.default)(end).format('HH.mm, D MMM YYYY')}`;
};
const LIMIT = 10;
const PulseSurveyDropdownOccurrences = ({ surveyId, selectedOccurrence, setSelectedOccurrence }) => {
    const currentPeriodText = selectedOccurrence &&
        dateFormatter(selectedOccurrence.startDate, selectedOccurrence.endDate);
    const changePeriodHandler = (data) => {
        setSelectedOccurrence(data);
    };
    return (react_1.default.createElement(Dropdown_1.default, null,
        react_1.default.createElement(Dropdown_1.default.Trigger, null,
            react_1.default.createElement(Trigger_1.default, { label: 'Period', text: currentPeriodText })),
        selectedOccurrence ? (react_1.default.createElement(DropdownContent, { selectedOccurrence: selectedOccurrence, surveyId: surveyId, changePeriodHandler: changePeriodHandler })) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
const DropdownContent = ({ selectedOccurrence, changePeriodHandler, surveyId }) => {
    const [defaultOccurrence] = (0, react_1.useState)(selectedOccurrence);
    const [ocurrenceLists, setOcurrenceLists] = (0, react_1.useState)([]);
    const [firstOccurrenceId] = (0, react_1.useState)(selectedOccurrence?.id);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const [loadingRef, setLoadingRef] = (0, react_1.useState)(null);
    const fetchOccurrence = (pageParams) => {
        const params = {
            olderThan: pageParams?.olderThan,
            state: ['current', 'past']
            // excludes: firstOccurrenceId, --> disable paginate #1
            // limit: LIMIT
        };
        return (0, adminClient_1.getSurveyOccurencesPerId)(surveyId, params);
    };
    const queryKey = ['occurrence-dropdown', surveyId, firstOccurrenceId];
    const { data: surveyDatas, isSuccess, isFetching, fetchNextPage } = (0, react_query_1.useInfiniteQuery)(queryKey, ({ pageParam }) => fetchOccurrence(pageParam), {
        getNextPageParam: (lastPage) => lastPage.pagination?.next || 0,
        staleTime: 500
    });
    const checkHasMore = (pages) => {
        const currentIndex = pages.length - 1;
        const currentPage = pages?.[currentIndex];
        if (!currentPage || !currentPage?.isSuccess)
            return;
        const currentData = currentPage.data;
        const nextPageParams = currentPage?.pagination?.next?.olderThan;
        setHasMore(currentData.length == LIMIT && nextPageParams);
    };
    (0, react_1.useEffect)(() => {
        if (!isSuccess && !surveyDatas)
            return;
        if (!isFetching && surveyDatas) {
            checkHasMore(surveyDatas?.pages);
            const newObj = (0, flatten_1.default)(surveyDatas?.pages?.map((page) => {
                if (page?.data) {
                    return page?.data?.map((d) => {
                        return d;
                    });
                }
            })).filter((data) => data);
            // setOcurrenceLists([defaultOccurrence, ...newObj]); --> disable paginate #2
            setOcurrenceLists([...newObj]);
        }
    }, [surveyDatas, isSuccess, isFetching, defaultOccurrence]);
    (0, react_1.useEffect)(() => {
        if (!loadingRef)
            return;
        const targetEl = loadingRef;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                if (entry.isIntersecting && hasMore && !isFetching) {
                    await fetchNextPage();
                }
            });
        }, options);
        observer.observe(targetEl);
        return () => {
            observer.disconnect();
        };
    }, [loadingRef, hasMore, isFetching, fetchNextPage]);
    return (react_1.default.createElement(Dropdown_1.default.MenuItems, { type: "absolute", position: "right", useScrollClose: true, maxHeight: 300, customContainerClass: "w-[310px]" },
        react_1.default.createElement(react_1.default.Fragment, null,
            ocurrenceLists?.map((data) => (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: data.id, onClick: () => changePeriodHandler(data), customClass: `justify-end ${data.id == selectedOccurrence.id ? '!bg-base-30024' : ''}` },
                react_1.default.createElement("p", { className: "flex justify-end w-full" }, dateFormatter(data.startDate, data.endDate))))),
            isFetching && react_1.default.createElement(LoadingComponent_1.default, null),
            react_1.default.createElement("div", { ref: (ref) => setLoadingRef(ref) }))));
};
exports.default = PulseSurveyDropdownOccurrences;
